import { vistaI18nRoutesBy99dLocale } from './vistaI18nRoutesBy99dLocale';

type LocaleUrlMap = Record<string, string> & {
    'en-at': string;
    'en-dk': string;
    'en-us': string;
};

const vistaprintLabelUrls: LocaleUrlMap = {
    'da-dk': '/etiketter-klistermaerker/specialdesignede-etiketter',
    'de-at': '/etiketten-und-aufkleber/personalisierte-etiketten',
    'de-ch': '/etiketten-und-aufkleber/personalisierte-etiketten',
    'de-de': '/etiketten-und-aufkleber/personalisierte-etiketten',
    'en-at': '/etiketten-und-aufkleber/personalisierte-etiketten',
    'en-au': '/labels-stickers/labels-tags',
    'en-ca': '/labels-stickers',
    'en-dk': '/etiketter-klistermaerker/specialdesignede-etiketter',
    'en-gb': '/labels-stickers/labels',
    'en-ie': '/labels-stickers',
    'en-in': '/marketing-materials/labels-stickers',
    'en-nz': '/labels-stickers',
    'en-sg': '/labels-stickers/labels',
    'en-us': '/labels-stickers/labels',
    'es-es': '/etiquetas-y-pegatinas/etiquetas',
    'es-us': '/etiquetas-adhesivos/etiquetas',
    'fi-fi': '/tarrat-etiketit/yksilolliset-etiketit',
    'fr-be': '/etiquettes-autocollants/etiquettes-personnalisees',
    'fr-ca': '/etiquettes-autocollants/etiquettes-personnalises',
    'fr-ch': '/etiquettes-autocollants/etiquettes-personnalisees',
    'fr-fr': '/etiquettes-autocollants/etiquettes-personnalisees',
    'it-ch': '/etichette-adesivi/etichette',
    'it-it': '/etichette-adesivi/etichette',
    'nl-be': '/labels-stickers/gepersonaliseerde-etiketten',
    'nl-nl': '/labels-stickers/gepersonaliseerde-etiketten',
    'no-no': '/klistremerker-etiketter/etichette',
    'nb-no': '/klistremerker-etiketter/etichette',
    'pt-pt': '/etiquetas-e-autocolantes/etiquetas',
    'sv-se': '/klistremerker-etiketter/personliga-etiketter',
};

const vistaprintPostcardUrls: LocaleUrlMap = {
    'da-dk': '/markedsfoerings-materialer/tilpassede-flyers',
    'de-at': '/marketingmaterial/benutzerdefinierte-flugblaetter',
    'de-ch': '/marketingmaterial/benutzerdefinierte-flugblaetter',
    'de-de': '/marketingmaterial/benutzerdefinierte-flugblaetter',
    'en-at': '/marketingmaterial/benutzerdefinierte-flugblaetter',
    'en-au': '/marketing-materials/postcards',
    'en-ca': '/marketing-materials/postcards',
    'en-dk': '/markedsfoerings-materialer/tilpassede-flyers',
    'en-gb': '/marketing-materials/postcards-marketing-handouts',
    'en-ie': '/marketing-materials/custom-handouts',
    'en-in': '/marketing-materials/postcards',
    'en-nz': '/marketing-materials/postcards',
    'en-sg': '/marketing-materials/postcards',
    'en-us': '/marketing-materials/postcards',
    'es-es': '/materiales-de-marketing/folletos-personalizados',
    'es-us': '/materiales-de-mercadeo/postales',
    'fi-fi': '/markkinointimateriaalit/postikortit',
    'fr-be': '/supports-marketing/documents-a-distribuer-personnalises',
    'fr-ca': '/supports-marketing/cartes-postales',
    'fr-ch': '/supports-marketing/documents-a-distribuer-personnalises',
    'fr-fr': '/supports-marketing/documents-a-distribuer-personnalises',
    'it-ch': '/prodotti-marketing/articoli-cartacei-da-distribuire-personalizzati',
    'it-it': '/prodotti-marketing/articoli-cartacei-da-distribuire-personalizzati',
    'nl-be': '/marketingmateriaal/bedrukte-hand-outs',
    'nl-nl': '/marketingmateriaal/bedrukte-hand-outs',
    'no-no': '/markedsfoeringsmateriale/egne-postkort-med-logo',
    'nb-no': '/markedsfoeringsmateriale/egne-postkort-med-logo',
    'pt-pt': '/materiais-de-marketing/materiais-publicitarios-personalizados',
    'sv-se': '/reklammaterial/specialdesignade-reklamblad',
};

const vistaprintTshirtUrls: LocaleUrlMap = {
    'da-dk': '/beklaedning-tasker/t-shirts',
    'de-at': '/kleidung-taschen/t-shirts',
    'de-ch': '/kleidung-taschen/t-shirts',
    'de-de': '/kleidung-taschen/t-shirts',
    'en-at': '/kleidung-taschen/t-shirts',
    'en-au': '/clothing-bags/t-shirts',
    'en-ca': '/clothing-bags/t-shirts',
    'en-dk': '/beklaedning-tasker/t-shirts',
    'en-gb': '/clothing-bags/t-shirts',
    'en-ie': '/clothing-bags/t-shirts',
    'en-in': '/clothing-bags/t-shirts',
    'en-nz': '/clothing-bags/t-shirts',
    'en-sg': '/clothing-bags/t-shirts',
    'en-us': '/clothing-bags/t-shirts',
    'es-es': '/ropa-y-bolsas/camisetas',
    'es-us': '/ropa-bolsas/camisetas',
    'fi-fi': '/vaatteet-kassit/t-paidat/kaikki-T-paidat',
    'fr-be': '/vetements-sacs/t-shirts',
    'fr-ca': '/vetements-sacs/t-shirts',
    'fr-ch': '/vetements-sacs/t-shirts',
    'fr-fr': '/vetements-sacs/t-shirts',
    'it-ch': '/abbigliamento-borse/magliette',
    'it-it': '/abbigliamento-borse/magliette',
    'nl-be': '/kleding-tassen/t-shirts',
    'nl-nl': '/kleding-tassen/t-shirts',
    'no-no': '/klaer-vesker/t-skjorter',
    'nb-no': '/klaer-vesker/t-skjorter',
    'pt-pt': '/vestuario-e-sacos/t-shirts/tudo-t-shirts',
    'sv-se': '/klader-och-vaskor/t-shirts',
};

const vistaprintPostcardFlyerUrls: LocaleUrlMap = {
    'da-dk': '/markedsfoerings-materialer/postkort-standard',
    'de-at': '/marketingmaterial/postkarten-klassisch',
    'de-ch': '/marketingmaterial/postkarten-klassisch',
    'de-de': '/marketingmaterial/postkarten-klassisch',
    'en-at': '/marketingmaterial/postkarten-klassisch',
    'en-au': '/marketing-materials/standard-postcards',
    'en-ca': '/marketing-materials/standard-postcards',
    'en-dk': '/markedsfoerings-materialer/postkort-standard',
    'en-gb': '/marketing-materials/standard-postcards',
    'en-ie': '/marketing-materials/standard-postcards',
    'en-in': '/marketing-materials/postcards',
    'en-nz': '/marketing-materials/standard-postcards',
    'en-sg': '/marketing-materials/standard-postcards',
    'en-us': '/marketing-materials/standard-postcards',
    'es-es': '/materiales-de-marketing/postales-estandar',
    'es-us': '/materiales-de-mercadeo/postales-standard',
    'fi-fi': '/markkinointimateriaalit/postikortit-omasta-kuvasta',
    'fr-be': '/supports-marketing/cartes-postales-classiques',
    'fr-ca': '/supports-marketing/cartes-postales-standard',
    'fr-ch': '/supports-marketing/cartes-postales-classiques',
    'fr-fr': '/supports-marketing/cartes-postales-classiques',
    'it-ch': '/prodotti-marketing/cartoline-standard',
    'it-it': '/prodotti-marketing/cartoline-standard',
    'nl-be': '/marketingmateriaal/standaard-ansichtkaarten',
    'nl-nl': '/marketingmateriaal/standaard-ansichtkaarten',
    'nb-no': '/markedsfoeringsmateriale/standard-postkort',
    'no-no': '/markedsfoeringsmateriale/standard-postkort',
    'pt-pt': '/materiais-de-marketing/postais-standard',
    'sv-se': '/reklammaterial/standard-vykort',
};

export type PrintCtaCategoryKey =
    | 'postcard-flyer-design'
    | 't-shirt-design'
    | 'business-card-design'
    | 'brochure-design'
    | 'sticker-design'
    | 'poster-design'
    | 'signage-design'
    | 'card-invitation-design'
    | 'menu-design'
    | 'cup-mug-design';

type Category = 'label' | 'postcard' | 'tshirt' | PrintCtaCategoryKey;

const vistaprintCardInvitationUrls: LocaleUrlMap = {
    'da-dk': '/invitationer-kort',
    'de-at': '/einladungen-karten',
    'de-ch': '/einladungen-karten',
    'de-de': '/einladungen-karten',
    'en-at': '/einladungen-karten',
    'en-au': '/invitations-cards',
    'en-ca': '/invitations-cards',
    'en-dk': '/invitationer-kort',
    'en-gb': '/invitations-cards',
    'en-ie': '/invitations-cards',
    'en-in': '/stationery/invitations-announcements',
    'en-nz': '/invitations-cards',
    'en-sg': '/stationery/celebration-invitations',
    'en-us': '/invitations-cards',
    'es-es': '/invitaciones-tarjetas',
    'es-us': '/invitaciones-tarjetas',
    'fi-fi': '/kutsut-kortit',
    'fr-be': '/cartes-d-invitation',
    'fr-ca': '/invitations-cartes',
    'fr-ch': '/cartes-d-invitation',
    'fr-fr': '/cartes-d-invitation',
    'it-ch': '/inviti-e-biglietti',
    'it-it': '/inviti-e-biglietti',
    'nl-be': '/uitnodigingen-en-kaarten',
    'nl-nl': '/uitnodigingen-en-kaarten',
    'nb-no': '/invitasjonskort',
    'no-no': '/invitasjonskort',
    'pt-pt': '/convites-postais',
    'sv-se': '/inbjudningar-kort',
};

const vistaprintStickerUrls: LocaleUrlMap = {
    'da-dk': '/etiketter-klistermaerker',
    'de-at': '/etiketten-und-aufkleber',
    'de-ch': '/etiketten-und-aufkleber',
    'de-de': '/etiketten-und-aufkleber',
    'en-at': '/etiketten-und-aufkleber',
    'en-au': '/labels-stickers',
    'en-ca': '/labels-stickers',
    'en-dk': '/etiketter-klistermaerker',
    'en-gb': '/labels-stickers',
    'en-ie': '/labels-stickers',
    'en-in': '/marketing-materials/labels-stickers',
    'en-nz': '/labels-stickers',
    'en-sg': '/labels-stickers',
    'en-us': '/labels-stickers',
    'es-es': '/etiquetas-y-pegatinas',
    'es-us': '/etiquetas-adhesivos',
    'fi-fi': '/tarrat-etiketit',
    'fr-be': '/etiquettes-autocollants',
    'fr-ca': '/etiquettes-autocollants',
    'fr-ch': '/etiquettes-autocollants',
    'fr-fr': '/etiquettes-autocollants',
    'it-ch': '/etichette-adesivi',
    'it-it': '/etichette-adesivi',
    'nl-be': '/labels-stickers',
    'nl-nl': '/labels-stickers',
    'nb-no': '/klistremerker-etiketter',
    'no-no': '/klistremerker-etiketter',
    'pt-pt': '/etiquetas-e-autocolantes',
    'sv-se': '/klistremerker-etiketter',
};

const vistaprintMenuUrls: LocaleUrlMap = {
    'da-dk': '/markedsfoerings-materialer/menukort',
    'de-at': '/marketingmaterial/speisekarten',
    'de-ch': '/marketingmaterial/speisekarten',
    'de-de': '/marketingmaterial/speisekarten',
    'en-at': '/marketingmaterial/speisekarten',
    'en-au': '/marketing-materials/menus',
    'en-ca': '/marketing-materials/menus',
    'en-dk': '/markedsfoerings-materialer/menukort',
    'en-gb': '/marketing-materials/menus',
    'en-ie': '/marketing-materials/menus',
    'en-in': '/marketing-materials/menu-cards',
    'en-nz': '/marketing-materials/menus',
    'en-sg': '/marketing-materials/menus',
    'en-us': '/marketing-materials/menus',
    'es-es': '/materiales-de-marketing/menus',
    'es-us': '/materiales-de-mercadeo/menus',
    'fi-fi': '/markkinointimateriaalit/ruokalistat',
    'fr-be': '/supports-marketing/menus',
    'fr-ca': '/supports-marketing/menus',
    'fr-ch': '/supports-marketing/menus',
    'fr-fr': '/supports-marketing/impression-de-menus',
    'it-ch': '/prodotti-marketing/stampa-menu',
    'it-it': '/prodotti-marketing/stampa-menu',
    'nl-be': '/marketingmateriaal/menukaarten-ontwerpen-en-drukken',
    'nl-nl': '/marketingmateriaal/menukaarten-ontwerpen-en-drukken',
    'nb-no': '/markedsfoeringsmateriale/print-menyer',
    'no-no': '/markedsfoeringsmateriale/print-menyer',
    'pt-pt': '/materiais-de-marketing/impressao-de-menus',
    'sv-se': '/reklammaterial/menykort',
};

const vistaprintCupMugUrls: LocaleUrlMap = {
    'da-dk': '/reklameartikler/specialdesignede-krus-og-vandflasker',
    'de-at': '/werbeartikel/trinkgefaesse',
    'de-ch': '/werbeartikel/trinkgefaesse',
    'de-de': '/werbeartikel/trinkgefaesse',
    'en-at': '/werbeartikel/trinkgefaesse',
    'en-au': '/promotional-products/drinkware',
    'en-ca': '/promotional-products/drinkware',
    'en-dk': '/reklameartikler/specialdesignede-krus-og-vandflasker',
    'en-gb': '/promotional-products/drinkware',
    'en-ie': '/promotional-products/drinkware',
    'en-in': '/photo-gifts/drinkware',
    'en-nz': '/promotional-products/drinkware',
    'en-sg': '/promotional-products/drinkware',
    'en-us': '/promotional-products/drinkware',
    'es-es': '/regalos-promocionales/tazas-botellas',
    'es-us': '/productos-promocionales/tazas-botellas',
    'fi-fi': '/mainostuotteet/mukautetut-lasit-mukit-ja-pullot/mukit',
    'fr-be': '/objets-publicitaires/verres-bouteilles',
    'fr-ca': '/produits-promotionnels/verres-tasses',
    'fr-ch': '/objets-publicitaires/verres-bouteilles',
    'fr-fr': '/objets-publicitaires/verres-bouteilles',
    'it-ch': '/articoli-promozionali/borracce-tazze',
    'it-it': '/articoli-promozionali/borracce-tazze',
    'nl-be': '/promotionele-producten/bedrukte-bekers-en-flesjes',
    'nl-nl': '/promotionele-producten/bedrukte-bekers-en-flesjes',
    'nb-no': '/reklameprodukter/tilpassede-drikkeflasker-og-krus/krus',
    'no-no': '/reklameprodukter/tilpassede-drikkeflasker-og-krus/krus',
    'pt-pt': '/produtos-promocionais/drinkware/canecas',
    'sv-se': '/reklamprodukter/anpassningsbara-muggar-och-vattenflaskor',
};

const vistaprintBrochureUrls: LocaleUrlMap = {
    'da-dk': '/markedsfoerings-materialer/brochurer',
    'de-at': '/marketingmaterial/falzflyer',
    'de-ch': '/marketingmaterial/falzflyer',
    'de-de': '/marketingmaterial/falzflyer',
    'en-at': '/marketingmaterial/falzflyer',
    'en-au': '/marketing-materials/folded-leaflets',
    'en-ca': '/marketing-materials/brochures',
    'en-dk': '/markedsfoerings-materialer/brochurer',
    'en-gb': '/marketing-materials/folded-leaflets',
    'en-ie': '/marketing-materials/folded-leaflets',
    'en-in': '/marketing-materials/brochures',
    'en-nz': '/marketing-materials/folded-leaflets',
    'en-sg': '/marketing-materials/folded-leaflets',
    'en-us': '/marketing-materials/brochures',
    'es-es': '/materiales-de-marketing/folletos-plegados',
    'es-us': '/materiales-de-mercadeo/folletos',
    'fi-fi': '/markkinointimateriaalit/taitellut-esitteet',
    'fr-be': '/supports-marketing/depliants',
    'fr-ca': '/supports-marketing/depliants',
    'fr-ch': '/supports-marketing/depliants',
    'fr-fr': '/supports-marketing/depliants',
    'it-ch': '/prodotti-marketing/stampa-di-depliant-pieghevoli',
    'it-it': '/prodotti-marketing/stampa-di-depliant-pieghevoli',
    'nl-be': '/marketingmateriaal/brochures',
    'nl-nl': '/marketingmateriaal/folders',
    'nb-no': '/markedsfoeringsmateriale/brosjyrer',
    'no-no': '/markedsfoeringsmateriale/brosjyrer',
    'pt-pt': '/materiais-de-marketing/flyers?Fold=Tri-Fold',
    'sv-se': '/reklammaterial/flyers',
};

const vistaprintPosterUrls: LocaleUrlMap = {
    'da-dk': '/skilte-plakater/plakater',
    'de-at': '/werbetechnik/poster',
    'de-ch': '/werbetechnik/poster',
    'de-de': '/werbetechnik/poster',
    'en-at': '/werbetechnik/poster',
    'en-au': '/signs-posters/advertising-posters',
    'en-ca': '/signs-posters/posters',
    'en-dk': '/skilte-plakater/plakater',
    'en-gb': '/signs-posters/promotional-posters',
    'en-ie': '/signs-posters/promotional-posters',
    'en-in': '/signs-posters/posters',
    'en-nz': '/signs-posters/advertising-posters',
    'en-sg': '/signs-posters/advertising-posters',
    'en-us': '/signs-posters/posters-family',
    'es-es': '/lonas-y-posteres/posteres',
    'es-us': '/carteles-posteres/posteres',
    'fi-fi': '/suurtulosteet-julisteet/julisteet',
    'fr-be': '/pancartes-affiches/posters',
    'fr-ca': '/produits-affichage/affiches',
    'fr-ch': '/pancartes-affiches/posters',
    'fr-fr': '/pancartes-affiches/posters',
    'it-ch': '/striscioni-poster/poster',
    'it-it': '/striscioni-poster/poster',
    'nl-be': '/borden-posters/posters',
    'nl-nl': '/borden-posters/posters',
    'nb-no': '/skilt-plakater/plakater',
    'no-no': '/skilt-plakater/plakater',
    'pt-pt': '/placas-e-posteres/posteres',
    'sv-se': '/skyltar-affischer/affischer',
};

const vistaprintSignageUrls: LocaleUrlMap = {
    'da-dk': '/skilte-plakater',
    'de-at': '/werbetechnik',
    'de-ch': '/werbetechnik',
    'de-de': '/werbetechnik',
    'en-at': '/werbetechnik',
    'en-au': '/signs-posters',
    'en-ca': '/signs-posters',
    'en-dk': '/skilte-plakater',
    'en-gb': '/signs-posters',
    'en-ie': '/signs-posters',
    'en-in': '/signs-posters',
    'en-nz': '/signs-posters',
    'en-sg': '/signs-posters',
    'en-us': '/signs-posters',
    'es-es': '/lonas-y-posteres',
    'es-us': '/carteles-posteres',
    'fi-fi': '/suurtulosteet-julisteet',
    'fr-be': '/pancartes-affiches',
    'fr-ca': '/produits-affichage',
    'fr-ch': '/pancartes-affiches',
    'fr-fr': '/pancartes-affiches',
    'it-ch': '/striscioni-poster',
    'it-it': '/striscioni-poster',
    'nl-be': '/borden-posters',
    'nl-nl': '/borden-posters',
    'nb-no': '/skilt-plakater',
    'no-no': '/skilt-plakater',
    'pt-pt': '/placas-e-posteres',
    'sv-se': '/skyltar-affischer',
};

const vistaprintBusinessCardUrls: LocaleUrlMap = {
    'da-dk': '/visit-kort',
    'de-at': '/visitenkarten',
    'de-ch': '/visitenkarten',
    'de-de': '/visitenkarten',
    'en-at': '/visitenkarten',
    'en-au': '/business-cards',
    'en-ca': '/business-cards',
    'en-dk': '/visit-kort',
    'en-gb': '/business-cards',
    'en-ie': '/business-cards',
    'en-in': '/business-cards',
    'en-nz': '/business-cards',
    'en-sg': '/name-cards',
    'en-us': '/business-cards',
    'es-es': '/tarjetas-de-visita',
    'es-us': '/tarjetas-de-presentacion',
    'fi-fi': '/kayntikortit',
    'fr-be': '/cartes-de-visite',
    'fr-ca': '/cartes-affaires',
    'fr-ch': '/cartes-de-visite',
    'fr-fr': '/cartes-de-visite',
    'it-ch': '/biglietti-da-visita',
    'it-it': '/biglietti-da-visita',
    'nl-be': '/visitekaartjes',
    'nl-nl': '/visitekaartjes',
    'nb-no': '/visittkort',
    'no-no': '/visittkort',
    'pt-pt': '/cartoes-de-visita',
    'sv-se': '/visitkort',
};

const vistaprintProductUrls: Record<PrintCtaCategoryKey, LocaleUrlMap> = {
    'postcard-flyer-design': vistaprintPostcardFlyerUrls,
    't-shirt-design': vistaprintTshirtUrls,
    'business-card-design': vistaprintBusinessCardUrls,
    'brochure-design': vistaprintBrochureUrls,
    'sticker-design': vistaprintStickerUrls,
    'poster-design': vistaprintPosterUrls,
    'signage-design': vistaprintSignageUrls,
    'card-invitation-design': vistaprintCardInvitationUrls,
    'menu-design': vistaprintMenuUrls,
    'cup-mug-design': vistaprintCupMugUrls,
};

const fallbackLocale = 'en-us';

const categoryUrlsMap: Record<Category, LocaleUrlMap> = {
    label: vistaprintLabelUrls,
    postcard: vistaprintPostcardUrls,
    tshirt: vistaprintTshirtUrls,
    ...vistaprintProductUrls,
};

const fallbackCategoryUrlsMap: { [key in Category]: string } = {
    label: vistaprintLabelUrls[fallbackLocale],
    postcard: vistaprintPostcardUrls[fallbackLocale],
    tshirt: vistaprintTshirtUrls[fallbackLocale],
    'postcard-flyer-design': vistaprintPostcardFlyerUrls[fallbackLocale],
    't-shirt-design': vistaprintTshirtUrls[fallbackLocale],
    'business-card-design': vistaprintBusinessCardUrls[fallbackLocale],
    'brochure-design': vistaprintBrochureUrls[fallbackLocale],
    'sticker-design': vistaprintStickerUrls[fallbackLocale],
    'poster-design': vistaprintPosterUrls[fallbackLocale],
    'signage-design': vistaprintSignageUrls[fallbackLocale],
    'card-invitation-design': vistaprintCardInvitationUrls[fallbackLocale],
    'menu-design': vistaprintMenuUrls[fallbackLocale],
    'cup-mug-design': vistaprintCupMugUrls[fallbackLocale],
};

// Usages:
//  vistaI18nRoutesBy99dLocaleAndCategory("en-US", "label")
//  vistaI18nRoutesBy99dLocaleAndCategory("en-us", "postcard")
//  vistaI18nRoutesBy99dLocaleAndCategory("de-at", "tshirt")

export function vistaI18nRoutesBy99dLocaleAndCategory(locale: string, category: Category): string {
    const categoryUrls = categoryUrlsMap[category];
    const fallbackUrl = fallbackCategoryUrlsMap[category];
    const cleanedUpLocale = locale.replace('_', '-').toLowerCase();
    const localizedUrl = categoryUrls[cleanedUpLocale];

    return `${vistaI18nRoutesBy99dLocale(cleanedUpLocale)}${localizedUrl || fallbackUrl}`;
}
